// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f9e5a9;
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin: 0.3rem;
  min-width: 1rem;
  border-radius: 8px;
  padding: 3px; }
`, "",{"version":3,"sources":["webpack://./src/components/library/Badge.scss","webpack://./src/style/colors.scss"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBCNkB;EDOlB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY,EAAA","sourcesContent":["@import \"./../../style/colors\";\n\n.Badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: $background;\n  color: #000;\n  font-size: 1rem;\n  font-weight: bold;\n  margin: 0.3rem;\n  min-width: 1rem;\n  border-radius: 8px;\n  padding: 3px;\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
